<template>
  <div>
    <KTCodePreview :title="title">
      <template v-slot:toolbar>
        <b-button size="sm" variant="secondary" @click="goBack">
          <i class="la la-arrow-left"></i> Quay lại
        </b-button>
      </template>
      <template v-slot:preview>
        <DayLimitJobTitleConfig
          v-if="jobTitleId"
          :job-title-id="jobTitleId"
          :job-title-name="jobTitleName"
        />
        <div v-else class="text-center text-muted py-5">
          <i class="flaticon2-information" style="font-size: 3rem; opacity: 0.3"></i>
          <p class="mt-3">Không tìm thấy chức vụ</p>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import DayLimitJobTitleConfig from '@/view/components/DayLimitJobTitleConfig.vue';

export default {
  name: 'DayLimitJobTitleUpsert',
  components: { KTCodePreview, DayLimitJobTitleConfig },
  computed: {
    jobTitleId() {
      return Number(this.$route.query.jobTitleId) || null;
    },
    jobTitleName() {
      return this.$route.query.jobTitleName || '';
    },
    title() {
      return this.jobTitleName ? `Giới hạn ngày xem/xuất excel/chỉnh sửa cho chức vụ: ${this.jobTitleName}` : 'Cấu hình giới hạn ngày';
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phân quyền', route: '/permissions' },
      { title: 'Giới hạn ngày' },
    ]);
  },
  methods: {
    goBack() {
      // Trang này luôn được mở từ tab "Giới hạn ngày" nên quay lại đúng tab đó
      this.$router.push({ name: 'list-permissions', query: { tab: 'day-limit' } });
    },
  },
};
</script>
